// Small in-memory cache for read-only backend answers that only change when the customer
// does something (Circle status, coin balance, the reward list for a given cart).
// It lives for the page visit — never in storage — and is cleared on logout / order done, so
// leaving the cart and coming back (e.g. after closing a "Customise" sheet) costs no API calls.
const store = new Map();

export const cacheGet = (key) => {
  const hit = store.get(key);
  if (!hit) return undefined;
  if (hit.expiresAt < Date.now()) {
    store.delete(key);
    return undefined;
  }
  return hit.value;
};

export const cacheSet = (key, value, ttlMs) => {
  store.set(key, { value, expiresAt: Date.now() + ttlMs });
};

// With a prefix: drop only those keys (e.g. "circle:"); without: drop everything.
export const cacheClear = (prefix) => {
  [...store.keys()].forEach((key) => {
    if (!prefix || key.startsWith(prefix)) store.delete(key);
  });
};
